<section class="disabled">
	<p data-test="activity-item-title">
		{{ activity.title | language }}
	</p>

	<small>
		<i class="fa fa-clock-o"></i>
		<span data-test="activity-item-time"
			>{{ activity.start | date: "HH:mm" }} - {{ activity.end | date: "HH:mm" }}</span
		>
	</small>
</section>
